export { default } from './UserEdit'


// WEBPACK FOOTER //
// ./src/scenes/Administration/User/UserEdit/index.js